module.exports = __webpack_public_path__ + "static/media/slider5.26c7459e.jpg";